<template>
  <div>
    <div class="sidebar-container">
      <div class="top">
        <FriedH3 class="title">{{ $t('try-out-this-stunning-template') }}</FriedH3>
        <SidebarInfoItem :text="$t('editable-text-and-live-changes')" icon="edit" />
        <SidebarInfoItem :text="$t('attach-demo-videos-and-presentations')" icon="camera" />
        <SidebarInfoItem :text="$t('negotiate-and-chat-communicate')" icon="conversation" />
        <SidebarInfoItem :text="$t('send-for-signatures')" icon="signature" />
        <div class="action-button-group">
          <FriedButton
            data-external="signup-template-signup-modal-button"
            :centered="true"
            @click="signup"
          >
            <FriedIcon class="icon" icon="plus-large" />
            {{ $t('start-using-this-template') }}
          </FriedButton>
        </div>
      </div>
      <div class="footer-container">
        <img class="footer-image" src="../../assets/img/signup-teamplate-image-nobg.png" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SidebarInfoItem from './SidebarInfoItem.vue';

export default defineComponent({
  name: 'SignupTemplateSidebar',
  components: {
    SidebarInfoItem,
  },
  emits: ['signup'],
  setup(_, { emit }) {
    const signup = () => {
      emit('signup');
    };
    return { signup };
  },
});
</script>

<style lang="scss" scoped>
.sidebar-container {
  position: fixed;
  top: 5rem;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  box-shadow: var(--shadow-1);
  border-radius: var(--radius-medium);

  .top {
    padding: var(--spacing-200) var(--spacing-100);
  }

  .action-button-group {
    margin: var(--spacing-50) 0;

    button {
      margin: var(--spacing-50) 0;
      width: 100%;

      .icon {
        margin-right: var(--spacing-50);
      }
    }
  }

  .footer-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .footer-image {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}
</style>
